import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, listField } from './util';
import { TournamentTeam } from './tournament-team';
import { TeamUser } from './team-user';
import { TournamentDisqualification } from './tournament-disqualification';
import { LeaguePlayer } from './league-player';
import { TournamentTeamUserFieldValue } from './tournament-team-user-field-value';

@ModelInstance({
  mappingFields: {
    id: 'id',
    active: 'active',
    tournament_team: 'tournamentTeam',
    team_user: 'teamUser',
    disqualified: 'disqualified',
    disqualification: 'disqualification',
    conditional_disqualification: 'conditionalDisqualification',
    league_player: 'leaguePlayer',
    games_count: 'gamesCount',
    mvp_count: 'mvpCount',
    field_values: 'fieldValues',
  },
  relation: {
    tournamentTeam: TournamentTeam,
    teamUser: TeamUser,
    disqualification: TournamentDisqualification,
    conditionalDisqualification: TournamentDisqualification,
    leaguePlayer: LeaguePlayer,
    fieldValues: listField(TournamentTeamUserFieldValue),
  }
})
export class TournamentTeamUser extends BaseModel {
  id: number;
  active: boolean;
  tournamentTeam: TournamentTeam;
  teamUser: TeamUser;
  disqualified: boolean;
  disqualification: TournamentDisqualification;
  conditionalDisqualification: TournamentDisqualification;
  leaguePlayer: LeaguePlayer;
  gamesCount: number;
  mvpCount: number;
  fieldValues: TournamentTeamUserFieldValue[];

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
